import React from "react";
import { Button, Tooltip } from "@mui/material";
import { AccountTreeOutlined } from "@mui/icons-material";
import PropTypes from "prop-types";

const TraceIdLink = ({ traceId, onClick }) => {
  if (!traceId) return null;

  return (
    <Tooltip title="Click to view trace details" describeChild>
      <Button
        size="small"
        variant="text"
        startIcon={<AccountTreeOutlined fontSize="small" />}
        onClick={() => onClick(traceId)}
        sx={{
          minWidth: 0,
          p: 0,
          justifyContent: "flex-start",
          color: "#f97316",
          fontWeight: 700,
          fontSize: "0.78rem",
          lineHeight: 1.4,
          textTransform: "none",
          textDecoration: "underline",
          textUnderlineOffset: "2px",
          wordBreak: "break-all",
          "&:hover": {
            color: "#ea580c",
            backgroundColor: "transparent",
            textDecoration: "underline",
          },
        }}
      >
        Trace ID: {traceId}
      </Button>
    </Tooltip>
  );
};

TraceIdLink.propTypes = {
  traceId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default TraceIdLink;
